<script type="text/javascript">
    // const picURL = 'http://192.168.2.88:9090'
    const picURL = '/uploads/image' // 图片显示
    // const uploderPicURL = 'http://121.40.191.9/uploads'
    const uploderPicURL = '/gov-api/authc/uploadFile' // 上传文件
    // const uploderPicURL = 'http://192.168.2.88:8080/gov-api/authc/uploadFile' // 测试环境上传文件

    export default
    {
        picURL,
        uploderPicURL
    }
</script>



// WEBPACK FOOTER //
// src/components/global.vue